/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { HyperFormula } from '../../HyperFormula';
import { FunctionPlugin } from './FunctionPlugin';
const LICENSE_STATUS_MAP = new Map([
    ['agpl-v3', 1],
    ['non-commercial-and-evaluation', 2],
    ["missing" /* MISSING */, 3],
    ["invalid" /* INVALID */, 4],
    ["expired" /* EXPIRED */, 5],
]);
export class VersionPlugin extends FunctionPlugin {
    version(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('VERSION'), () => {
            const { licenseKeyValidityState: validityState, licenseKey, } = this.config;
            let status;
            if (LICENSE_STATUS_MAP.has(licenseKey)) {
                status = LICENSE_STATUS_MAP.get(licenseKey);
            }
            else if (LICENSE_STATUS_MAP.has(validityState)) {
                status = LICENSE_STATUS_MAP.get(validityState);
            }
            else if (validityState === "valid" /* VALID */) {
                status = licenseKey.slice(-5);
            }
            return `HyperFormula v${HyperFormula.version}, ${status}`;
        });
    }
}
VersionPlugin.implementedFunctions = {
    'VERSION': {
        method: 'version',
        parameters: [],
    },
};
